import React, { useState, useContext } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ModalStyles
import styles from "./../StaffManagment.module.css";
import ModalStyles from "./../../DashboardReuseAbleComponents/Modal.module.css";

export default function DeleteConsultantModal(props) {
  const { userToken } = useContext(UserContext);
  const [deleteData, setDeleteData] = useState({
    deleteReason: "",
  });

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <style type="text/css">
        {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
      </style>

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>حذف مشاور</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div dir="rtl" className="w-100 d-flex flex-column align-items-center justify-content-center flex-wrap px-3 mb-3">
            <h3 className={`${styles.title_modal_body_files_box}`}> لطفا دلیل حذف مشاور را وارد کنید </h3>
            <div className={`pt-3 w-50 ${styles.total_percentage_modal_body_files_box}`}>
              <Form.Group className="position-relative">
                <Form.Label className={`w-100 mb-3 text-right ${styles.title_percentage_modal_body_files_box}`}> دلیل حذف مشاور </Form.Label>
                <Form.Control
                  className={`${styles.form_percentage_modal_body_files_box} shadow-none`}
                  type="text"
                  id="deleteReason"
                  name="deleteReason"
                  value={deleteData.deleteReason}
                  onChange={changeHandler}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            <div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.outlined_btn}`} onClick={props.onHide}>
              انصراف
            </div>

            <div className={`d-flex align-items-center justify-content-center ms-3 bg-danger ${ModalStyles.filled_btn}`} onClick={deleteHandler}>
              حذف مشاور
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  function changeHandler(event) {
    setDeleteData(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  async function deleteHandler() {
    try {
      if (deleteData.deleteReason) {
        var deleteConsultantData = {
          consultantId: props.id,
          reason: deleteData.deleteReason,
        };
        // console.log(deleteConsultantData)

        const apiData = await axios.post("Consultant/DeleteConsultant", deleteConsultantData, {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(apiData)
        notify("مشاور حذف شد", "success");
        props.onHide();
      } else {
        notify("لطفا ابتدا دلیل را وارد کنید", "error");
      }
    } catch (error) {
      // console.log(error)
      notify("خطایی رخ داد", "error");
    }
  }
}
